import router from '../../router'

const state = {
  menuItem: {},
  data: {},
  source: null,
  apiMessage: null
}

const getters = {
  get: state => {
    return state
  }
}

const actions = {
  set ({ commit }, routerData) {
    commit('set', routerData)
  },
  setSource ({ commit }, source) {
    commit('setSource', source)
  },
  setApiMessage ({ commit }, message) {
    commit('setApiMessage', message)
  }
}

const mutations = {
  set (state, routerData) {
    state.menuItem = routerData.menuItem
    state.data = routerData.data
    if (state.menuItem.target === 'result') {
      router.push({ path: `/result/${state.data.id}` })
    } else if (state.menuItem.target === 'analyze') {
      let path = '/analyze/'.concat(state.data.analyze_target_code)
      let routeTarget = {
        path: path,
        query: {
          history_id: state.data.id
        }
      }
      console.log(routeTarget)
      router.push(routeTarget)
    } else if (state.menuItem.target === 'reservation') {
      let path = '/analyze/'.concat(state.data.analyze_target_code)
      let routeTarget = {
        path: path,
        query: {
          history_id: state.data.id,
          is_reservation: 1
        }
      }
      router.push(routeTarget)
    }
  },
  setSource (state, source) {
    state.source = source
  },
  setApiMessage (state, message) {
    state.apiMessage = message
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
